import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import { removeItemFromLocalStorage } from "../../../utils/localStorageHelper";
import { clearAuthStatusChangeCommentsFromLocalStorage } from "./helperForAuthStatusCommentsInLocalStorage";

/**
 * Clears all order-related data from local storage for a specific order.
 *
 * This function removes all cached data associated with an order, including:
 * - J-code documents
 * - Business office comments
 * - CPT codes
 * - Global business office values
 * - Existing J-code documents
 * - J-codes
 * - Authorization status change comments
 *
 * @param orderId - The unique identifier of the order whose data should be cleared
 *
 * @returns void
 */
export const clearDataFromLocalStorage = (orderId: string) => {
  removeItemFromLocalStorage(`${LocalStorageKeys.JCode_Docs}_${orderId}`);
  removeItemFromLocalStorage(`${LocalStorageKeys.BO_COMMENTS}_${orderId}`);
  removeItemFromLocalStorage(`${LocalStorageKeys.CPT_CODES}_${orderId}`);
  removeItemFromLocalStorage(`${LocalStorageKeys.GLOBAL_BO_VALUE}_${orderId}`);
  removeItemFromLocalStorage(
    `${LocalStorageKeys.EXISTING_JCODE_DOCS}_${orderId}`,
  );
  removeItemFromLocalStorage(`${LocalStorageKeys.J_CODES}_${orderId}`);
  clearAuthStatusChangeCommentsFromLocalStorage(orderId);
};
